import React from 'react';

// material-ui
import {
    Chip,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@mui/material/styles';

// project import
import DeleteAlert from './DeleteAlert';
import { USER_STATUS } from 'store/constant';
import ColoredDropdown from 'views/User/SimpleSpeedDials';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

export default function TurfList({ rows, handleClickOpen, setReload, sportsTypes }) {

    const theme = useTheme();

    const getSportsType = function (typesString) {
        const splitTypes = typesString.split(',');
        return splitTypes.map(x => {
            let findInd = sportsTypes.findIndex(st => st.code === x);
            return findInd >= 0 ? sportsTypes[findInd].display_name : '';
        }).toString();
    };

    const changeStatus = (rowUuid) => {
        changeTurfStatusApi.execute(rowUuid);
    };

    const changeStatusHandler = () => {
        setReload(r => !r);
    };

    const changeTurfStatusApi = useApi(VenueService.changeTurfStatusByUuid, changeStatusHandler, true);

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ pl: 3 }}>#</TableCell>
                            <TableCell>Court Name</TableCell>
                            <TableCell>Sports Type</TableCell>
                            <TableCell align="center">Board Available</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center" sx={{ pr: 3 }}>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.map((row, index) =>
                                <TableRow key={index} hover>
                                    <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                    <TableCell>{row.turf_name}</TableCell>
                                    <TableCell>
                                        {getSportsType(row.sports_type)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {
                                            row.is_board_available ? (
                                                <Chip
                                                    label="Yes"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.success.light + 60,
                                                        color: theme.palette.success.dark
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label="No"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.error.light + 60,
                                                        color: theme.palette.error.dark
                                                    }}
                                                />
                                            )
                                        }
                                    </TableCell>
                                    <TableCell align="center">
                                        <ColoredDropdown
                                            itemArray={USER_STATUS}
                                            selectedValue={row.is_active}
                                            rowUuid={row.uuid}
                                            handleChange={changeStatus}
                                        />
                                    </TableCell>
                                    <TableCell align="center" sx={{ pr: 3 }}>
                                        <Stack direction="row" justifyContent="center" alignItems="center">
                                            <Tooltip placement="top" title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    aria-label="delete"
                                                    size="large"
                                                    onClick={() => handleClickOpen(row.uuid)}
                                                >
                                                    <EditIcon sx={{ fontSize: '1.1rem' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <DeleteAlert setReload={setReload} turfUuid={row.uuid} />
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer >
        </>
    );
};